module.exports = __webpack_public_path__ + "img/nav-bg-ac.b89607e9.png";